module.exports = __webpack_public_path__ + "static/media/opptimise_logo_big.4a90137f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/opptimise_logo_big.png
// module id = 138
// module chunks = 0